import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/auth'
import { AppShell } from '@/components/layout/AppShell'
import { ErrorBoundary } from '@/components/layout/ErrorBoundary'
import { LoadingState } from '@/components/ui/states'
import LoginPage from '@/pages/Login'
import DashboardPage from '@/pages/Dashboard'
import DomainLibraryPage from '@/pages/DomainLibrary'
import RegistrarsPage from '@/pages/Registrars'
import RegistrarProvidersPage from '@/pages/RegistrarProviders'
import RegistrarCallsPage from '@/pages/RegistrarCalls'
import SemanticsPage from '@/pages/Semantics'
import TagRulesPage from '@/pages/TagRules'
import RegistrationPage from '@/pages/Registration'
import DomainQueryPage from '@/pages/DomainQuery'
import RulesPage from '@/pages/Rules'
import RuleEditorPage from '@/pages/RuleEditor'
import MonitoringPage from '@/pages/Monitoring'
import EventsPage from '@/pages/Events'
import ReleaseAnalyticsPage from '@/pages/ReleaseAnalytics'
import NotificationsPage from '@/pages/Notifications'
import SettingsPage from '@/pages/Settings'
import AdminPage from '@/pages/Admin'
import UsersPage from '@/pages/Users'

export default function App() {
  const { user, ready } = useAuth()
  const location = useLocation()

  if (!ready) {
    return (
      <div className="mx-auto max-w-md p-8">
        <LoadingState rows={3} label="正在恢复会话" />
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <AppShell>
      {/* Inside the shell, so a page that fails to render does not take the
          navigation with it — the person can still click their way out. */}
      <ErrorBoundary resetKey={location.pathname}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/domains" element={<DomainLibraryPage />} />
        <Route path="/registrars" element={<RegistrarsPage />} />
        <Route path="/semantics" element={<SemanticsPage />} />
        <Route path="/registration" element={<RegistrationPage />} />
        {user.role === 'admin' && (
          <Route path="/registrar-providers" element={<RegistrarProvidersPage />} />
        )}
        {user.role === 'admin' && (
          <Route path="/registrar-calls" element={<RegistrarCallsPage />} />
        )}
        <Route path="/domains/:id" element={<DomainLibraryPage />} />
        <Route path="/query" element={<DomainQueryPage />} />
        <Route path="/rules" element={<RulesPage />} />
        <Route path="/rules/new" element={<RuleEditorPage />} />
        {user.role === 'admin' && <Route path="/tag-rules" element={<TagRulesPage />} />}
        <Route path="/rules/:id" element={<RuleEditorPage />} />
        <Route path="/monitoring" element={<MonitoringPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/release-analytics" element={<ReleaseAnalyticsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        {user.role === 'admin' && <Route path="/admin" element={<AdminPage />} />}
        {user.role === 'admin' && <Route path="/users" element={<UsersPage />} />}
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
    </AppShell>
  )
}
